module.exports = __webpack_public_path__ + "static/media/011.04a652f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/011.jpg
// module id = 308
// module chunks = 0